import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { LogoutControllerModule } from './controllers/LogoutController';

export const LogoutView = angular
  .module('acme.view.logout', [uiRouter, 'ui.bootstrap', LogoutControllerModule])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const logout = {
      name: 'logout',
      url: '/logout',
      abstract: true,
      views: {
        main: {
          controller: 'LogoutController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
    };

    const logoutDefault = {
      name: 'logout.default',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/logout/logout.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
        pageTitle: 'Logout',
      },
    };

    $stateProvider.state(logout).state(logoutDefault);
  }).name;
